/**
 * Filtra el `returnUrl` con el que se vuelve tras iniciar sesión.
 *
 * Existe por el botón del correo del comité: «Ir a la sesión» aterriza en `/comites/sesion/:id`, y si la
 * sesión caducó el interceptor manda a `/login?returnUrl=…` para volver ahí después. Ese parámetro lo
 * escribe el navegador y lo puede escribir cualquiera, así que **solo se honra si es una ruta de este
 * panel**:
 *
 * - Tiene que empezar por `/` y no por `//` ni `/\`: `//evil.com` es una URL protocol-relative y el
 *   navegador se iría de dominio; `/\evil` la normaliza Chrome a lo mismo.
 * - No lleva esquema antes del primer `/`, `?` o `#` (`/javascript:alert(1)` no es una ruta).
 * - Nunca es `/login` (con o sin query): volver al login desde el login es el bucle que B-044 ya cerró.
 *
 * Devuelve `null` cuando no se honra, para que quien llama caiga a la landing del rol.
 */
export function safeReturnUrl(raw: string | null | undefined): string | null {
  const value = (raw ?? '').trim()
  if (!value.startsWith('/')) return null
  if (value.startsWith('//') || value.startsWith('/\\')) return null
  if (/^\/[^/?#]*:/.test(value)) return null
  if (/^\/login(?:[/?#]|$)/.test(value)) return null

  return value
}
